import { InternalAxiosRequestConfig } from "axios";
import { UserService } from "src/services/UserService";
import { DebugService } from "src/services/DebugService";
import { getEnv } from "src/utils/getEnv";

export const getApiUrl = (): string => {
    const hostname = window.location.hostname;
    const protocol = window.location.protocol;
    const subdomain = hostname.split(".")[0];
    const apiUrl = getEnv("VITE_API_URL");

    if (hostname.startsWith("localhost") || hostname === "foodpilot.ngrok.app") {
        return apiUrl;
    }

    if (subdomain === "app") {
        return `${protocol}//api.${hostname.split(".").slice(1).join(".")}`;
    }

    // Only dev environments need the -app suffix
    if (hostname.endsWith("foodpilot.tech")) {
        // Handle the scenario where subdomain finish by -app or -app-{env}, avoiding multiple "app" matching pitfall
        const matches = subdomain.match(/(.+)(-app-)([-\w]*)$/);
        if (matches) {
            const [, schema, , env] = matches;
            return `${protocol}//${schema}-api-${env}.${hostname.split(".").slice(1).join(".")}`;
        }
    }

    // All remaining cases are just about suffixing the subdomain with "-api"
    return `${protocol}//${hostname.split(".")[0]}-api.${hostname.split(".").slice(1).join(".")}`;
};

export const getSureApiUrl = (): string => {
    const runtimeSureUrl = window.__RUNTIME_CONFIG__?.SURE_URL;
    if (typeof runtimeSureUrl === "string" && runtimeSureUrl.trim().length > 0) {
        return runtimeSureUrl;
    }

    return getEnv("VITE_SURE_API_URL");
};

export const handleImpersonation = (config: InternalAxiosRequestConfig<any>): InternalAxiosRequestConfig<any> => {
    const token = UserService.getFullToken();

    if (token.connectedAs) {
        config.headers["X-SWITCH-USER"] = token.connectedAs;
    } else {
        // Ensuring the request NEVER impersonates someone if
        // token doesn't exist.
        delete config.headers["X-SWITCH-USER"];
    }
    return config;
};

export const handleProfiling = (config: InternalAxiosRequestConfig<unknown>): InternalAxiosRequestConfig<unknown> => {
    if (DebugService.isProfilingEnabled()) {
        const url = new URL(config.url ?? "", config.baseURL);
        url.searchParams.set("profile", "1");
        config.url = url.pathname + url.search;
    }
    return config;
};

type QueryRequirements = {
    isLoading: boolean;
    isFetched: boolean;
    isRefetching: boolean;
};
export const isQueryReady = (query: QueryRequirements, isQueryEnabled: boolean): boolean => {
    const isReady = query.isLoading === false && (query.isFetched === true || isQueryEnabled === false);
    return isReady;
};
